import { useEffect, useRef, useState } from "react";
import { Spinner, TextField } from "@radix-ui/themes";
import { twMerge } from "tailwind-merge";

export function SkuScanner({
  onScanned,
  isFetching,
}: {
  className?: string;
  onScanned?: (value: string) => void;
  isFetching?: boolean;
}) {
  const [input, setInput] = useState("");
  const inputRef = useRef<HTMLInputElement | null>(null);

  useEffect(() => {
    const onKeyDown = (e: KeyboardEvent) => {
      if (
        !e.ctrlKey &&
        !e.shiftKey &&
        !e.metaKey &&
        e.key !== " " &&
        !Number.isNaN(Number(e.key))
      ) {
        if (document.activeElement instanceof HTMLInputElement) return;
        inputRef.current?.focus();
      }
    };

    document.addEventListener("keydown", onKeyDown);
    return () => document.removeEventListener("keydown", onKeyDown);
  }, []);

  return (
    <TextField.Root
      ref={inputRef}
      value={input}
      autoFocus
      onChange={(e) => setInput(e.target.value)}
      placeholder="Scan the barcode"
      className={twMerge([
        import.meta.env.PROD && "!h-0 overflow-hidden opacity-0",
      ])}
      onKeyDown={(e) => {
        if (e.key === "Enter") {
          onScanned?.(input);
          setInput("");
        }
      }}
      mb="2"
    >
      <TextField.Slot side="right">{isFetching && <Spinner />}</TextField.Slot>
    </TextField.Root>
  );
}
